import { tickerItems } from '@/mocks/homeData';

export default function LiveTicker() {
  const loopItems = [...tickerItems, ...tickerItems];

  return (
    <section id="live" aria-labelledby="live-title" className="scroll-mt-28">
      <div className="bg-foreground-950 text-background-100">
        <div className="mx-auto flex max-w-[1400px] flex-col gap-4 px-4 py-10 md:px-6 md:py-12">
          <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
            <div>
              <p className="flex items-center gap-2 text-xs tracking-[0.25em] text-accent-400">
                <i className="ri-radar-line" aria-hidden="true" />
                LIVE FEED
              </p>
              <h2 id="live-title" className="mt-2 font-heading text-2xl font-bold text-background-50 md:text-3xl">
                实时速递
              </h2>
            </div>
            <p className="max-w-md text-xs leading-relaxed text-background-300 md:text-sm">
              速递内容按时间滚出,鼠标悬停可暂停查看,编辑组每小时核对一次来源。
            </p>
          </div>

          <div className="relative overflow-hidden rounded-lg border border-background-50/15 bg-background-50/5 py-4">
            <div className="flex items-center gap-4">
              <span className="z-10 ml-4 hidden shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs text-background-50 sm:inline-flex">
                <i className="ri-flashlight-fill" aria-hidden="true" />
                正在更新
              </span>
              <div className="ticker-track whitespace-nowrap">
                {loopItems.map((item, index) => (
                  <span
                    key={`${item}-${index}`}
                    className="mx-6 inline-flex items-center gap-2 text-sm text-background-200"
                  >
                    <i className="ri-arrow-right-s-fill text-accent-400" aria-hidden="true" />
                    {item}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}